import { useState } from "react";
import { useLang } from "@/i18n";

export default function CookieBanner() {
  const { t } = useLang();
  const [visible, setVisible] = useState(!localStorage.getItem("mw_cookie_ok"));
  if (!visible) return null;
  return (
    <div data-testid="cookie-banner" className="fixed bottom-20 md:bottom-6 left-4 right-4 md:left-6 md:right-auto md:max-w-md z-50 card-dark p-4 shadow-2xl">
      <p className="text-xs text-zinc-400 leading-relaxed">{t("cookie.text")}</p>
      <button
        data-testid="cookie-accept-btn"
        onClick={() => { localStorage.setItem("mw_cookie_ok", "1"); setVisible(false); }}
        className="mt-3 btn-red !px-4 !py-2 text-xs w-full md:w-auto"
      >
        {t("cookie.accept")}
      </button>
    </div>
  );
}
